import { render } from "./ContactsPage.vue?vue&type=template&id=04176e4c&scoped=true"
import script from "./ContactsPage.vue?vue&type=script&lang=ts"
export * from "./ContactsPage.vue?vue&type=script&lang=ts"

import "./ContactsPage.vue?vue&type=style&index=0&id=04176e4c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-04176e4c"

export default script